<template>
  <el-dialog title="2025年投资日历" :visible.sync="calendarDialogVisible" class="calendar-dialog" width="1200px" center>
    <el-tabs v-model="activeName" stretch @tab-click="handleClick">
      <el-tab-pane v-for = "(item, i) in array" :key="i" :label="item.text" :name="item.name" ><img :src="item.con" alt=""></el-tab-pane>
    </el-tabs>
    <!--        <div class="case-img"><img src="../assets/images/imgBg.png" alt=""></div>-->
    <span slot="footer" class="dialog-footer"></span>
  </el-dialog>
</template>

<script>
export default {
  name: "Calendar",
  data() {
    return{
      calendarDialogVisible: false,
      activeName:'third',
      array: [
        {
          text: "一月",
          con: require('../../assets/images/2025年历-1.png'),
          name: "first"
        }, {
          text: "二月",
          con: require('../../assets/images/2025年历-2.png'),
          name: "second"
        },
        {
          text: "三月",
          con: require('../../assets/images/2025年历-3.png'),
          name: "third"
        },
        {
          text: "四月",
          con: require('../../assets/images/2025年历-4.png'),
          name: "fourth"
        },
        {
          text: "五月",
          con: require('../../assets/images/2025年历-5.png'),
          name: "five"
        },
        {
          text: "六月",
          con: require('../../assets/images/2025年历-6.png'),
          name: "six"
        },
        {
          text: "七月",
          con: require('../../assets/images/2025年历-7.png'),
          name: "seven"
        },
        {
          text: "八月",
          con: require('../../assets/images/2025年历-8.png'),
          name: "eight"
        },
        {
          text: "九月",
          con: require('../../assets/images/2025年历-9.png'),
          name: "nine"
        },
        {
          text: "十月",
          con: require('../../assets/images/2025年历-10.png'),
          name: "ten"
        },
        {
          text: "十一月",
          con: require('../../assets/images/2025年历-11.png'),
          name: "eleven"
        },
        {
          text: "十二月",
          con: require('../../assets/images/2025年历-12.png'),
          name: "twelve"
        }
      ],
    }
  },
  methods:{
    handleClick(tab, event) {
      console.log(tab, event);
    },
    init(data){
      this.calendarDialogVisible=true;
      //data是父组件弹窗传递过来的值，我们可以打印看看
      // console.log(data);
    },
  }
}
</script>

<style scoped>
.calendar-dialog img{
  /* 修改图片宽度为 800px */
  width: 800px;
  /* 使图片水平居中 */
  display: block;
  margin: 0 auto;
}

>>>.el-dialog__body {
  padding: 3px 30px;
  overflow-y: auto;
  height: calc(100vh - 160px);
}

>>>.el-dialog__title{
  font-size: 36px!important;
}


>>>.el-dialog__header{
  padding: 30px 20px 20px;
}

>>>.el-dialog__headerbtn .el-dialog__close {
  color: black!important;
  background-color: white!important;
}

>>>.el-dialog__headerbtn .el-dialog__close {
  color: black!important;
  background-color: white!important;
}

>>> .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}

>>> .el-tabs__content {
  padding: 10px;
}

>>> .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background-color: rgba(255, 255, 255, 100);
  color: rgba(97, 154, 241, 100);
}

>>> .el-tabs__nav-wrap:after {
  background-color: transparent;
}

>>> .el-tabs__active-bar {
  background-color: transparent;
}

>>> .el-tabs__item {
  border-radius: 10px;
  font-size: 14px;
  margin: 0 5px;
  background-color: rgba(255, 255, 255, 1);
  color: rgba(35, 129, 254, 1);
}

>>> .el-tabs__item.is-active {
  background-color: rgba(35, 129, 254, 1);
  color: rgba(255, 255, 255, 1);
}

>>> .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding-left: 20px;
}

>>> .el-tabs--top .el-tabs__item.is-top:last-child {
  padding-right: 20px;
}

>>>.el-dialog {
  border-radius: 20px;
  margin-top: 8vh!important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Calendar.vue